import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromFormActions from '../form/form.actions';
import * as fromGroupActions from './group.actions';
import { Group } from './group.model';
import { updateFromApiReducer } from './update-from-api.reducer';

export interface State {
    ids: Array<string>;
    entities: {[id: string]: Group};
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(
    state = initialState,
    action: fromGroupActions.Actions | fromFormActions.Actions
): State {
    switch (action.type) {
        case fromGroupActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromGroupActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromGroupActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromFormActions.UPDATE_FROM_API: {
            return updateFromApiReducer(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/group/group.reducer.ts